import Vue from "vue";

import Static from "./Static.vue";

export function load(payload) {
    const selector = "static";
    const store = payload;
    // Is the custom Vue root element in the DOM?
    if (!document.querySelector(selector)) {
        return;
    }

    // Create a new Vue app with the imported Home component
    new Vue({
        store,
        render: createElement =>
            createElement(Static, {
                props: {
                    ...window[selector],
                },
            }),
    }).$mount(selector);
}